import "./src/styles/global.css";
import { StoreContextProvider } from "./src/context/StoreContext";
import React from "react";

export const wrapRootElement = ({ element }) => {
  return <StoreContextProvider>{element}</StoreContextProvider>;
};
